import { render } from "./icon-refresh.vue?vue&type=template&id=65776d9e"
import script from "./icon-refresh.vue?vue&type=script&lang=js"
export * from "./icon-refresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__